import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { UserNotificationType } from 'users/enums/user-notification-type.enum';
import { UserNotification } from 'users/interfaces/user-notification.interface';

export interface ButtonActionConfig {
    icon: string;
    tooltip: string;
    visible: boolean;
    clickAction: () => void;
}

@Injectable({ providedIn: 'root' })
export class UserNotificationActionsService {
    constructor(private router: Router) {}

    // Generates a list of buttons based on the notification type
    // The first button in this list will be used in the "notification preview" menu when new notifications are available.
    public getActionButtonsForNotification(notification: UserNotification): ButtonActionConfig[] {
        switch (notification.notificationType) {
            case UserNotificationType.SNAPSHOT_GENERATION: {
                const notificationListingId = notification.userNotificationMetadataItems?.find((item: any) => item.key === 'listingId');
                const hasListingId = notificationListingId && notificationListingId.value;
                return [
                    {
                        icon: 'arrow-up-right-from-square',
                        tooltip: 'generalKeywords.viewListing',
                        visible: !!hasListingId,
                        clickAction: () => {
                            if (hasListingId) {
                                this.router.navigate(['listings/details', notificationListingId.value, 'listingProfile']);
                            }
                        },
                    },
                ];
            }

            default:
                return [];
        }
    }
}
